import { Switch } from 'react-native';

function Toggle(props: React.ComponentPropsWithoutRef<typeof Switch>) {
  return (
    <Switch
      trackColor={{
        true: '#8FF3E7',
        false: '#F5F5F5'
      }}
      thumbColor="#FFFFFF"
      {...props}
    />
  );
}

export { Toggle };
